var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "requirements__wrapper" },
    _vm._l(_vm.requirements, function (category) {
      return _c(
        "Accordion",
        {
          key: category.tid,
          staticClass: "requirements__body",
          attrs: {
            id: category.tid,
            full: _vm.full,
            active: true,
            "dir-button": true,
            "dir-button-left": true,
            title: category.categoryName,
            size: "accordion-heading",
            level: "requirement",
          },
          on: {
            loadLicenses: _vm.accordionChange,
            initiallyExpanded: _vm.initiallyExpandedAccordion,
          },
        },
        _vm._l(category.children, function (topic) {
          return _c(
            "div",
            { key: topic.tid, staticClass: "requirements__inner" },
            [
              _c("h2", { staticClass: "heading" }, [
                _vm._v("\n        " + _vm._s(topic.categoryName) + "\n      "),
              ]),
              _vm._v(" "),
              _vm.hasAccess
                ? _c("div", {
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.externalLinks(topic.requirement.content)
                      ),
                    },
                  })
                : _c("div", { staticClass: "unauthorised" }, [
                    _vm._v(_vm._s(_vm.noAccessShort)),
                  ]),
              _vm._v(" "),
              topic.requirement.licenses.length > 0 && _vm.reports
                ? _c("div", [
                    _c(
                      "i",
                      [
                        _vm._v("Relevant to: \n          "),
                        _vm._l(
                          topic.requirement.licenses,
                          function (license, lKey) {
                            return _c("span", { key: lKey }, [
                              _vm._v(
                                "\n            " +
                                  _vm._s(license) +
                                  _vm._s(
                                    _vm.hasComma(
                                      lKey,
                                      topic.requirement.licenses.length
                                    )
                                  ) +
                                  "\n          "
                              ),
                            ])
                          }
                        ),
                      ],
                      2
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm._l(topic.requirement.references, function (ref, index) {
                return _c("div", { key: index }, [
                  _vm.hasAccess
                    ? _c("a", { attrs: { href: ref.uri } }, [
                        _vm._v(_vm._s(ref.title)),
                      ])
                    : _vm._e(),
                ])
              }),
              _vm._v(" "),
              _c("RequirementHistory", {
                attrs: { requirements: topic.requirement.history },
              }),
            ],
            2
          )
        }),
        0
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }